<template>
  <div class="right-side" style="border:0px solid red;width:100%;height:100%;">
    <row>
      <div style="text-align: center; font-size: xx-large;">
        <div class="logo-lg">
          <img :src="img_url.img_no_permission" class="resize">
        </div>
      </div>
    </row>
  </div>
</template>

<script>
import configuration from "../../lib/config";
export default {
  name: 'CommingSoon',
  data () {
    return {
      img_url: configuration.imgUrlConfig,
    }
  },
  methods: {
    clickToSmallBox () {
      alert('click!!!: clickToSmallBox')
    }
  },
  components: {}
}

</script>
<style scoped>
.resize{
    height: auto; 
    width: auto; 
    max-width: 800px; 
    max-height: 800px;
}
.right-side {
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/views/CommingSoon/CommingSoon.vue